import Rest from '../Rest'

export default class ProductCancellationRuleService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/product_cancellation_rules'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  forProduct(productId: number) {
    return this.get(`/for_product/${productId}`)
  }

  setForProduct(productId: number, policyId: number | null) {
    return this.post(`/for_product/${productId}`, { policy_id: policyId })
  }
}
